const API_PORT = process.env.REACT_APP_BACKEND_PORT;
const API_PREFIX = process.env.REACT_APP_BACKEND_PREFIX;
const API_URL = `${window.location.protocol}//${API_PREFIX}${window.location.hostname}${API_PORT}`;

export default API_URL;
